import MuiAlert from '@mui/material/Alert';
import styled from 'styled-components';

export const StyledMuiAlert = styled(MuiAlert)`
    font-family: inherit !important;
`;
